import React, { useEffect, useState } from "react";
import {
  View,
  StyleSheet,
  TouchableOpacity,
  ScrollView,
  KeyboardAvoidingView,
  ActivityIndicator} from "react-native";
import AntDesign from "@expo/vector-icons/AntDesign";
import { ApiService } from "../../../service/ApiService";
import { SafeAreaView } from "react-native-safe-area-context";
import commonStyles from "../../../styles/commonStyles";
import Toast from "react-native-toast-message";
import AsyncStorage from "@react-native-async-storage/async-storage";
import Feather from "@expo/vector-icons/Feather";
import CommonDropdown from "../../../components/Dropdown";
import BankDetailsView from "./ProfileBankDetailsView";
import { statesArray } from "../Address/statesArray";
import { IUpdatedUserData, IUserTypes } from "../../../types/IUserTypes";
import { fonts } from "../../../styles/theme";
import AppText from "../../../components/AppText";
import AppTextInput from "../../../components/AppTextInput";

type BankDetailsProps = {
  navigation: {
    navigate: (screen: string) => void;
    goBack: () => void;
  };
};

type FormData = {
  bankName?: string;
  accountNumber?: string;
  wireRoutingNumber?: string;
  achRoutingNumber?: string;
  zelleId?: string;
  address?: {
    street1?: string;
    street2?: string;
    city?: string;
    state?: string;
    zipCode?: string;
  };
};

const BankDetails: React.FC<BankDetailsProps> = ({ navigation }) => {
  const [isEnabled, setIsEnabled] = useState(false);
  const [isEditable, setIsEditable] = useState(false);
  const [isAddressVisible, setIsAddressVisible] = useState(false);
  const [userData, setUserData] = useState<IUserTypes>();
  const [loading, setLoading] = useState<boolean>(false);
  const [formData, setFormData] = useState<FormData>({
    bankName: "",
    accountNumber: "",
    wireRoutingNumber: "",
    achRoutingNumber: "",
    zelleId: "",
    address: {
      street1: "",
      street2: "",
      city: "",
      state: "",
      zipCode: ""}});

  const fetchUserData = async () => {
    try {
      const apiResponse = await AsyncStorage.getItem("apiResponse");
      console.log("this is the apiresponse " + apiResponse);
      const parsedData = JSON.parse(apiResponse || "{}");
      setUserData(parsedData);
    } catch (error) {
      console.error("Error fetching user data:", error);
    }
  };

  useEffect(() => {
    if (userData) {
      setFormData({
        bankName: userData.bankDetail?.bankName || "",
        accountNumber: userData.bankDetail?.accountNumber || "",
        wireRoutingNumber: userData.bankDetail?.wireRoutingNumber || "",
        achRoutingNumber: userData.bankDetail?.achRoutingNumber || "",
        zelleId: userData.bankDetail?.zelleId || "",
        address: {
          street1: userData.bankDetail?.address?.street1 || "",
          street2: userData.bankDetail?.address?.street2 || "",
          city: userData.bankDetail?.address?.city || "",
          state: userData.bankDetail?.address?.state || "",
          zipCode: userData.bankDetail?.address?.zipCode || ""}});
    }
  }, [userData]);
  useEffect(() => {
    fetchUserData();
  }, []);

  const [isFocused, setIsFocused] = useState<Record<string, boolean>>({});

  const handleFocus = (field: string) =>
    setIsFocused({ ...isFocused, [field]: true });
  const handleBlur = (field: string) =>
    setIsFocused({ ...isFocused, [field]: false });
  const handleChange = (field: keyof FormData, value: string) => {
    setFormData({ ...formData, [field]: value });
  };

  const handleAddressChange = (field: string, value: string) => {
    setFormData({
      ...formData,
      address: {
        ...formData.address,
        [field]: value}});
  };

  const handleSubmit = async () => {
    if (!userData) return;
    console.log("userdata", userData);
    setLoading(true);
    const updatedUserData: IUpdatedUserData = {
      id: userData.id,
      firstName: userData.firstName,
      lastName: userData.lastName,
      middleName: userData.middleName,
      gender: userData.gender,
      employmentStatus: userData.employmentStatus,
      householdIncome: userData.householdIncome,
      phoneNumber: userData.phoneNumber,
      maritalStatus: userData.maritalStatus,
      accreditedInvestor: userData.accreditedInvestor,
      immigrationStatus: userData.immigrationStatus,
      address: {
        street1: userData.address?.street1,
        street2: userData.address?.street2,
        city: userData.address?.city,
        state: userData.address?.state,
        zipCode: userData.address?.zipCode},
      bankDetail: {
        bankName: formData.bankName,
        accountNumber: formData.accountNumber,
        wireRoutingNumber: formData.wireRoutingNumber,
        achRoutingNumber: formData.achRoutingNumber,
        zelleId: formData.zelleId,
        address: {
          street1: formData.address?.street1,
          street2: formData.address?.street2,
          city: formData.address?.city,
          state: formData.address?.state,
          zipCode: formData.address?.zipCode}}};

    console.log("update user data", updatedUserData);
    if (
      !updatedUserData.householdIncome ||
      !updatedUserData.phoneNumber ||
      !updatedUserData.gender ||
      !updatedUserData.maritalStatus ||
      !updatedUserData.employmentStatus
    ) {
      Toast.show({
        type: "error",
        text1: "Please fill all the required fields"});
      setLoading(false);
      navigation.navigate("PersonalDetails");
    } else {
      try {
        const apiUrl = `portal/partner/${userData.id}`;
        const response = await ApiService.put<IUserTypes>(
          apiUrl,
          updatedUserData
        );
        console.log("this is the response by me ", response);
        updatedUserData.userRoles = userData.userRoles;
        updatedUserData.email = userData.email;
        await AsyncStorage.setItem(
          "apiResponse",
          JSON.stringify(updatedUserData)
        );
        Toast.show({
          type: "success",
          text1: "Data updated successfully!"});

        setLoading(false);
        setUserData(response.data);
        setIsEditable(false);
        setIsEnabled(false);
      } catch (error) {
        console.error("Error updating user data:", error);
        Toast.show({
          type: "error",
          text1: "Failed to update data. Please try again."});
        setLoading(false);
      }
    }
  };

  const onEdit = () => {
    setIsEditable(!isEditable);
    setIsEnabled(!isEnabled);
  };
  return (
    <SafeAreaView
      edges={["bottom", "left", "right"]}
      style={[styles.container, commonStyles.screenBottomGap]}
    >
      <View style={commonStyles.subHeaderContainer}>
        <TouchableOpacity
          testID="back-btn"
          style={commonStyles.subHeaderContainer}
          onPress={navigation.goBack}
        >
          <AntDesign name="left" size={24} color="black" />
          <AppText style={commonStyles.subHeader}>Bank Details</AppText>
        </TouchableOpacity>
        <View style={styles.switchContainer}>
          <TouchableOpacity onPress={onEdit} testID="edit-button">
            <Feather
              name="edit"
              size={24}
              color="black"
              style={commonStyles.mr8}
            />
          </TouchableOpacity>
          {/* <Switch
            value={isEnabled}
            onValueChange={(value) => {
              setIsEnabled(value);
            }}
          /> */}
        </View>
      </View>
      {!isEditable && userData ? (
        <BankDetailsView userData={userData} />
      ) : (
        <KeyboardAvoidingView style={{ flex: 1 }} behavior="padding">
          <ScrollView
            contentContainerStyle={styles.scrollContainer}
            keyboardShouldPersistTaps="handled"
          >
            {/* <View
              style={[
                commonStyles.subContainer,
                commonStyles.p16,
                commonStyles.mlar5,
              ]}
            > */}
            <View>
              <AppText style={styles.label}>Bank Name</AppText>
              <AppTextInput
                style={styles.input}
                placeholder="Enter Bank Name"
                placeholderTextColor="#979797"
                value={formData.bankName}
                editable={isEditable}
                onChangeText={(value) => handleChange("bankName", value)}
              />
            </View>

            <View>
              <AppText style={styles.label}>Account Number</AppText>
              <AppTextInput
                testID="AccountNum"
                style={styles.input}
                placeholder="Enter Account Number"
                placeholderTextColor="#979797"
                value={formData.accountNumber}
                editable={isEditable}
                onChangeText={(value) => handleChange("accountNumber", value)}
                keyboardType="phone-pad"
              />
            </View>

            <View>
              <AppText style={styles.label}>Wire Routing Number</AppText>
              <AppTextInput
                style={styles.input}
                placeholder="Enter Wire Routing Number"
                placeholderTextColor="#979797"
                value={formData.wireRoutingNumber}
                editable={isEditable}
                onChangeText={(value) =>
                  handleChange("wireRoutingNumber", value)
                }
                keyboardType="phone-pad"
              />
            </View>

            <View>
              <AppText style={styles.label}>ACH Routing Number</AppText>
              <AppTextInput
                style={styles.input}
                placeholder="Enter ACH Routing Number"
                placeholderTextColor="#979797"
                value={formData.achRoutingNumber}
                editable={isEditable}
                onChangeText={(value) =>
                  handleChange("achRoutingNumber", value)
                }
                keyboardType="phone-pad"
              />
            </View>

            <View>
              <AppText style={styles.label}>Zelle ID</AppText>
              <AppTextInput
                style={styles.input}
                placeholder="Enter Zelle ID"
                placeholderTextColor="#979797"
                value={formData.zelleId}
                editable={isEditable}
                onChangeText={(value) => handleChange("zelleId", value)}
              />
            </View>

            <TouchableOpacity
              onPress={() => setIsAddressVisible(!isAddressVisible)}
              testID="collapse-button"
              style={[styles.collapsibleHeader]}
            >
              <AppText style={styles.collapsibleHeaderText}>Bank Address</AppText>
              <AntDesign
                name={isAddressVisible ? "up" : "down"}
                size={20}
                color="#666"
                style={styles.icon}
              />
            </TouchableOpacity>
            {isAddressVisible && (
              <View>
                <View>
                  <AppText style={styles.label}>Address 1</AppText>
                  <AppTextInput
                    style={styles.input}
                    placeholder="Enter Address 1"
                    placeholderTextColor="#979797"
                    value={formData.address?.street1}
                    editable={isEditable}
                    onChangeText={(value) =>
                      handleAddressChange("street1", value)
                    }
                  />
                </View>

                <View>
                  <AppText style={styles.label}>Address 2 (Optional)</AppText>
                  <AppTextInput
                    style={styles.input}
                    placeholder="Enter Address 2"
                    placeholderTextColor="#979797"
                    value={formData.address?.street2}
                    editable={isEditable}
                    onChangeText={(value) =>
                      handleAddressChange("street2", value)
                    }
                  />
                </View>

                <View>
                  <AppText style={styles.label}>City</AppText>
                  <AppTextInput
                    style={styles.input}
                    placeholder="Enter City"
                    placeholderTextColor="#979797"
                    value={formData.address?.city}
                    editable={isEditable}
                    onChangeText={(value) => handleAddressChange("city", value)}
                  />
                </View>

                <View>
                  <CommonDropdown
                    title="State"
                    isRequired={false}
                    data={statesArray.map((state) => ({
                      title: state.name,
                      value: state.value}))}
                    value={formData.address?.state ?? null}
                    onChange={(item) => {
                      handleAddressChange("state", item.value);
                    }}
                    placeholder="Select state"
                    isEditable={isEditable}
                  />
                </View>

                <View>
                  <AppText style={styles.label}>Zip Code</AppText>
                  <AppTextInput
                    style={styles.input}
                    placeholder="Zip Code"
                    placeholderTextColor="#979797"
                    value={formData.address?.zipCode}
                    editable={isEditable}
                    onChangeText={(value) =>
                      handleAddressChange("zipCode", value)
                    }
                  />
                </View>
              </View>
            )}

            {isEnabled && (
              <TouchableOpacity
                style={styles.button}
                onPress={handleSubmit}
                disabled={loading}
              >
                {loading ? (
                  <ActivityIndicator size="small" color="#fff" />
                ) : (
                  <AppText style={styles.buttonText} testID="Update-btn">
                    Update
                  </AppText>
                )}
              </TouchableOpacity>
            )}
            {/* </View> */}
          </ScrollView>
        </KeyboardAvoidingView>
      )}
    </SafeAreaView>
  );
};

const styles = StyleSheet.create({
  container: {
    flex: 1,
    padding: 20,
    backgroundColor: "#fff"},
  backButtonContainer: {
    flexDirection: "row",
    alignItems: "center",
    marginBottom: 20},
  backButtonText: {
    fontSize: 18,
    fontWeight: "600",
    marginLeft: 10,
    color: "#333"},
  scrollContainer: {
    paddingBottom: 20,
    paddingTop: 20},
  label: {
    marginBottom: 8,
    fontSize: 12,
    color: "#979797",
    fontWeight: "600",
    fontFamily: fonts.regular},
  icon: {
    marginRight: 5},

  input: {
    height: 45,
    borderWidth: 1,
    borderRadius: 15,
    paddingHorizontal: 12,
    fontSize: 14,
    color: "#343434",
    marginBottom: 10,
    fontWeight: "600",
    // backgroundColor: "#f9f9f9",
    borderColor: "#CBCBCB",
    fontFamily: fonts.regular},

  placeholderText: {
    fontSize: 14,
    color: "#979797",
    fontWeight: "500",
    fontFamily: fonts.regular},

  redStar: {
    color: "#343434"},
  button: {
    backgroundColor: "#3629B7",
    paddingVertical: 15,
    borderRadius: 10,
    alignItems: "center",
    marginTop: 20},
  buttonText: {
    color: "#fff",
    fontSize: 16,
    fontWeight: "600",
    fontFamily: fonts.regular},
  switchContainer: {
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "space-between",
    marginLeft: "auto"},
  disabledInput: {
    backgroundColor: "#f0f0f0",
    color: "#999"},
  collapsibleHeader: {
    flexDirection: "row",
    justifyContent: "space-between",
    alignItems: "center",
    paddingVertical: 10,
    backgroundColor: "#FFFFF",
    borderRadius: 5,
    marginBottom: 12},
  collapsibleHeaderText: {
    fontSize: 16,
    fontWeight: "bold",
    fontFamily: fonts.regular},
  collapsibleContent: {
    padding: 10,
    backgroundColor: "#fff",
    borderWidth: 1,
    borderColor: "#ddd",
    borderRadius: 5,
    marginTop: 8}});

export default BankDetails;
